import React from 'react';
import ActionMenu from '../../../common/action/ActionMenu';
import { ListCell } from '../../../common/cells/ListCell';
import StatusCell from '../../../common/cells/StatusCell';
import { MultiSelectFilterFn } from '../../../common/filters/Filters';
import MultiSelectColumnFilter from '../../../common/filters/MultiSelectColumnFilter';
import StateMultiSelectColumnFilter, { StateMultiSelectFilterFn } from '../../../common/filters/StateMultiSelectColumnFilter';
import TextColumnFilter from '../../../common/filters/TextColumnFilter';


export const columns = (refresh) => {
    return [
        {
            Header: 'Státusz',
            accessor: 'state',
            id: 'state',
            show: true,
            className: 'status',
            Filter: StateMultiSelectColumnFilter,
            filter: StateMultiSelectFilterFn,
            Cell: props => <StatusCell row={props.row.original} />,
        },
        {
            Header: 'Adónem sorszáma',
            accessor: 'publicId',
            id: 'publicId',
            show: true,
            className: 'idColumn center',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Adónem megnevezése',
            accessor: 'name',
            id: 'name',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Jelenlegi Bankszámlaszámok',
            accessor: 'currentBankAccountNumbers',
            id: 'currentBankAccountNumbers',
            show: true,
            Cell: props => <ListCell cell={props} delimiter=', ' />,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Fizetési nap',
            accessor: 'paymentDay',
            id: 'paymentDay',
            show: true,
            className: 'idColumn right',
            Filter: TextColumnFilter,
        },
        {
            Header: 'Típus',
            accessor: 'taxPaymentTypeLabel',
            id: 'taxPaymentTypeLabel',
            show: true,
            Filter: MultiSelectColumnFilter,
            filter: MultiSelectFilterFn,
        },
        {
            id: 'menu',
            show: true,
            headerClassName: 'actions',
            className: 'actions',
            Header: () => null, // No header
            Cell: value => <ActionMenu row={value.row.original} tabletype={'taxtype'} refresh={refresh} />,
        },
    ]
}